import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseServiceWithFilter } from './base.service';
import { CommandResult } from '@cl/shared/models/misc/command-result.model';
import { lastValueFrom } from 'rxjs';
import { EstimatePositionTypeFilter } from '@cl/shared/models/estimate-position-type/estimate-position-type-filter.model';
import { EstimatePositionType } from '@cl/shared/models';

@Injectable({ providedIn: 'root' })
export class EstimatePositionTypesService extends BaseServiceWithFilter<EstimatePositionType, EstimatePositionTypeFilter> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/estimate-position-types/');
    }

    getEstimatePositionTypesForOrder(ordersTypeId: number, scontractId: number): Promise<CommandResult<EstimatePositionType[]>> {
        return lastValueFrom(
            this.httpClient.get<CommandResult<EstimatePositionType[]>>(`${this.baseApiUrl}for-order/${ordersTypeId}/${scontractId}`),
        );
    }
}
